import React, { useState } from "react";
import "./Pages/PagesCss/Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log("Form submitted:", formData);
    alert("Thank you for your message! We'll get back to you soon.");
    setFormData({ name: "", email: "", subject: "", message: "" });
  };

  return (
    <div className="contact-container">
      {/* Header Section */}
      <div className="contact-header">
        <div className="header-content">
          <div className="header-badge">
            <span>Contact Us</span>
          </div>
          <h1>Let's Start a Conversation</h1>
          <p>
            We're here to help and answer any questions you might have. 
            We look forward to hearing from you.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="contact-content">
        {/* Contact Methods */}
        <div className="contact-methods">
          <div className="method-card">
            <div className="method-icon">
              <i className="fa-solid fa-envelope"></i>
            </div>
            <h3>Email Us</h3>
            <p>Send us an email anytime</p>
            <a href="mailto:support@font-max.com">support@font-max.com</a>
          </div>

          <div className="method-card">
            <div className="method-icon">
              <i className="fa-solid fa-location-dot"></i>
            </div>
            <h3>Visit Us</h3>
            <p>Come see us in person</p>
            <span>2568 Madison Ave, League City, TX 77573</span>
          </div>
        </div>

        {/* Contact Form & Map Section */}
        <div className="contact-main">
          {/* Contact Form */}
          <div className="form-section">
            <div className="form-header">
              <h2>Send us a Message</h2>
              <p>Fill out the form below and we'll get back to you shortly</p>
            </div>
            
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="input-group">
                <div className="input-field">
                  <label htmlFor="name">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Your full name"
                  />
                </div>
                <div className="input-field">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your.email@example.com"
                  />
                </div>
              </div>
              
              <div className="input-field">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="What is this regarding?"
                />
              </div>
              
              <div className="input-field">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  placeholder="Tell us how we can help you..."
                ></textarea>
              </div>
              
              <button type="submit" className="submit-button">
                <span>Send Message</span>
                <i className="fa-solid fa-arrow-right"></i>
              </button>
            </form>
          </div>

          {/* Map Section */}
          <div className="map-section">
            <div className="map-header">
              <h2>Our Location</h2>
              <p>Find us at our office in League City</p>
            </div>
            <div className="map-container">
              <iframe
                title="Office Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3455.123456789!2d-95.079!3d29.507!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640f123456789ab%3A0xabcdef123456789!2s2568%20Madison%20Ave%2C%20League%20City%2C%20TX%2077573%2C%20USA!5e0!3m2!1sen!2sus!4v169XXXXXXX"
                loading="lazy"
                allowFullScreen
              ></iframe>
            </div>
            <div className="location-info">
              <div className="info-item">
                <i className="fa-solid fa-location-dot"></i>
                <div>
                  <strong>Address</strong>
                  <span>2568 Madison Ave, League City, TX 77573</span>
                </div>
              </div>
              <div className="info-item">
               <i className="fa-solid fa-envelope"></i>
                <div>
                  <strong>Email</strong>
                  <span>support@font-max.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> 
  );
};

export default Contact;